// Ficheiros anexados a contratos (endpoints documento-contrato/). Usado pelo
// formulário do contrato e pelos detalhes na Gestão de Contratos.
import axios from "axios";
import { toast } from "vue3-toastify";

const EXTENSOES_IMAGEM = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
const EXTENSOES_VISUALIZAVEIS = [".pdf", ...EXTENSOES_IMAGEM];

const ICONES = {
  ".pdf": "fa-solid fa-file-pdf text-[#E74C3C]",
  ".doc": "fa-solid fa-file-word text-[#2E86C1]",
  ".docx": "fa-solid fa-file-word text-[#2E86C1]",
  ".xls": "fa-solid fa-file-excel text-[#229954]",
  ".xlsx": "fa-solid fa-file-excel text-[#229954]",
  ".xlsm": "fa-solid fa-file-excel text-[#229954]",
  ".csv": "fa-solid fa-file-csv text-[#229954]",
  ".zip": "fa-solid fa-file-zipper text-[#F39C12]",
  ".rar": "fa-solid fa-file-zipper text-[#F39C12]",
};

export function iconeFicheiro(extensao) {
  if (ICONES[extensao]) return ICONES[extensao];
  if (EXTENSOES_IMAGEM.includes(extensao)) return "fa-solid fa-file-image text-[#9B59B6]";
  return "fa-solid fa-file";
}

export function formatarTamanho(bytes) {
  if (!bytes) return "0 B";
  const unidades = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), 3);
  return `${Math.round((bytes / Math.pow(1024, i)) * 10) / 10} ${unidades[i]}`;
}

// PDF e imagens abrem num separador novo; o resto é descarregado.
// Com `descarregar` força o download mesmo para PDF/imagens.
export async function abrirDocumentoContrato(doc, { descarregar = false } = {}) {
  const visualizavel = !descarregar && EXTENSOES_VISUALIZAVEIS.includes(doc.extensao);
  // A janela abre já, ainda dentro do clique; aberta depois do await o
  // browser trata-a como popup e bloqueia-a.
  const janela = visualizavel ? window.open("", "_blank") : null;
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_URL_BASE}/api/v1/documento-contrato/${doc.id}/view/`,
      { responseType: "blob" },
    );
    const url = window.URL.createObjectURL(response.data);
    if (janela) {
      janela.location.href = url;
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.download = doc.nome_original;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch (error) {
    if (janela) janela.close();
    toast.error("Erro ao abrir o ficheiro");
  }
}
